/**
 * CSRF Token utilities.
 * Reads the XSRF-TOKEN cookie set by the server and provides helpers
 * for attaching it to outgoing requests.
 */

export function getCsrfToken() {
  const match = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}

/**
 * Returns headers object containing the CSRF token.
 * Merge into your fetch() headers or axios config.
 */
export function csrfHeaders() {
  const token = getCsrfToken();
  return token ? { 'X-XSRF-TOKEN': token } : {};
}
